
import { Component, Vue } from "vue-property-decorator";
import { namespace } from "vuex-class";
import { emptyToLine } from "@common/src/utils/common";
import t from "@common/src/i18n/t";
const testingItem = namespace("testing-item");

@Component({})
export default class TestItemEdit extends Vue {
  @testingItem.Action getTestItemsDetail;
  emptyToLine = emptyToLine;
  get breadData() {
    return [
      { name: this.$t("test.test-item"), path: "/setting/test-items" },
      { name: t("setting.details-test-items") }
    ];
  }
  get newTestItemList() {
    return [{}, {}];
  }
  created() {
    this.init();
  }
  get checkItemId() {
    return this.$route.params.id;
  }
  testItemInfo: any = {};
  init() {
    this.getTestItemsDetail({
      checkItemCode: this.checkItemId
    }).then(data => {
      this.testItemInfo = data.data;
    });
  }
  testItemData: any = {};
}
